export default __webpack_public_path__ + "static/media/ArrowLeft.759cb0d1.svg";